import React from 'react';
import './AboutUsStyles.css';
import AboutImg from './assets/d1.jpg'
import AboutImg2 from './assets/d2.jpg'
import AboutImg3 from './assets/d3.jpg'

const AboutUs = () => {
  return (
    <main className="about-page">
      

      <section className="intro-section">
        <div className="container">
          <div className="intro-content">
            <h2 className="section-title">Welcome To Surgy Life</h2>
            <p className="section-text">
              At Surgy Life, we redefine healthcare excellence by combining cutting-edge medical technology 
              with compassionate patient care. Our commitment to innovation, expertise, and personalized 
              treatment has made us a trusted name in surgical excellence across the region.
            </p>
            <div className="stats-grid">
              <div className="stat-item">
                <span className="stat-number">15+</span>
                <span className="stat-label">Years of Excellence</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">50K+</span>
                <span className="stat-label">Lives Transformed</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">98%</span>
                <span className="stat-label">Success Rate</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="story-section">
        <div className="container">
          <div className="story-content">
            <div className="story-text">
              <h2 className="section-title">Our Journey</h2>
              <p className="section-text">
                Founded on the principles of excellence and compassion, Surgy Life has evolved from 
                a small surgical practice to a comprehensive healthcare destination. Our journey is 
                marked by continuous innovation, dedication to patient care, and commitment to 
                advancing surgical techniques.
              </p>
              <div className="timeline">
                <div className="timeline-item">
                  <div className="timeline-year">2010</div>
                  <div className="timeline-content">
                    <h4>Foundation</h4>
                    <p>Established with a vision to provide world-class surgical care</p>
                  </div>
                </div>
                <div className="timeline-item">
                  <div className="timeline-year">2015</div>
                  <div className="timeline-content">
                    <h4>Expansion</h4>
                    <p>Expanded services to include specialized surgical departments</p>
                  </div>
                </div>
                <div className="timeline-item">
                  <div className="timeline-year">2020</div>
                  <div className="timeline-content">
                    <h4>Innovation</h4>
                    <p>Introduced cutting-edge robotic surgery and AI-assisted procedures</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="story-image">
              <img src="https://images.unsplash.com/photo-1576091160550-2173dba999ef?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="About Surgy Life" />
            </div>
          </div>
        </div>
      </section>

      <section className="values-section">
        <div className="container">
          <h2 className="section-title">Our Core Values</h2>
          <div className="values-grid">
            <div className="value-card">
              <div className="value-icon">❤️</div>
              <h3>Compassion</h3>
              <p>Putting patients first with empathy and understanding in every interaction.</p>
            </div>
            <div className="value-card">
              <div className="value-icon">🎯</div>
              <h3>Excellence</h3>
              <p>Striving for perfection in every procedure and patient outcome.</p>
            </div>
            <div className="value-card">
              <div className="value-icon">🔬</div>
              <h3>Innovation</h3>
              <p>Embracing cutting-edge technology and techniques for better outcomes.</p>
            </div>
            <div className="value-card">
              <div className="value-icon">🤝</div>
              <h3>Integrity</h3>
              <p>Maintaining the highest ethical standards in all our practices.</p>
            </div>
            <div className="value-card">
              <div className="value-icon">📚</div>
              <h3>Learning</h3>
              <p>Continuous education and skill development for our team.</p>
            </div>
            <div className="value-card">
              <div className="value-icon">🌟</div>
              <h3>Excellence</h3>
              <p>Delivering exceptional care that exceeds expectations.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="team-section">
        <div className="container">
          <h2 className="section-title">Meet Our Expert Team</h2>
          <div className="team-grid">
            <div className="team-card">
              <img src={AboutImg} className='img-fluid' alt="Dr. Arjun Reddy" />
              <h3>Dr. Arjun Reddy</h3>
              <p>Chief Cardiac Surgeon</p>
              <p>15+ years experience in cardiac surgery with expertise in minimally invasive procedures.</p>
            </div>
            <div className="team-card">
              <img src={AboutImg2} className='img-fluid w-100' alt="Dr. Priya Nair" />
              <h3>Dr. Priya Nair</h3>
              <p>Orthopedic Specialist</p>
              <p>12+ years specializing in joint replacement and sports medicine.</p>
            </div>
            <div className="team-card">
              <img src={AboutImg3} className='img-fluid w-100' alt="Dr. Ramesh Iyer" />
              <h3>Dr. Manoj</h3>
              <p>General Surgeon</p>
              <p>10+ years of experience in advanced laparoscopic and robotic surgery.</p>
            </div>
            <div className="team-card">
              <img src="https://i.pinimg.com/736x/68/12/31/681231a788e1aef1edd1d719349ff3ec.jpg" alt="Dr. Lakshmi Menon" />
              <h3>Dr. Lakshmi Menon</h3>
              <p>Pediatric Specialist</p>
              <p>8+ years dedicated to pediatric surgery and neonatal care.</p>
            </div>
            <div className="team-card">
              <img src="https://i.pinimg.com/736x/f3/d8/f5/f3d8f5b2d53936e4434415e1bac69987.jpg" alt="Dr. Anita Sharma" />
              <h3>Dr. Revanth</h3>
              <p>Neurologist</p>
              <p>14+ years in neurological disorders and brain surgery with expertise in minimally invasive techniques.</p>
            </div>
            <div className="team-card">
              <img src="https://i.pinimg.com/736x/7e/91/b7/7e91b721691322422919eec7dc039618.jpg" alt="Dr. Vikram Patel" />
              <h3>Dr. Anitha   Patel</h3>
              <p>Oncologist</p>
              <p>11+ years specializing in cancer treatment and surgical oncology with focus on precision medicine.</p>
            </div>

         
          </div>
        </div>
      </section>

      <section className="locations-section">
        <div className="container">
          <h2 className="section-title">Our Locations in Hyderabad</h2>
          <div className="locations-grid">
            <div className="location-card">
              <img src="https://media.assettype.com/thenewsminute%2Fimport%2Fsites%2Fdefault%2Ffiles%2FGandhi-Hospital_1200_Picxy.com-munna_(1).jpg?w=1200&ar=40%3A21&auto=format%2Ccompress&ogImage=true&mode=crop&enlarge=true&overlay=false&overlay_position=bottom&overlay_width=100" alt="Banjara Hills" />
              <div className="location-content">
                <h3>Gandhi Hospital</h3>
                <p> 🏥 Medicine & Surgery</p>
              
                <p>📍Musheerabad, Secunderabad - 500003 Bhoiguda Road, M.I.G.H colony,  Hyderabad</p>
                <p>📞 040-27505566/ 27505773
</p>
                <p>🕒 24/7 Emergency Services</p>
              </div>
            </div>
            <div className="location-card">
              <img src="https://pbs.twimg.com/media/FY5BbOzagAA3rzw.jpg" alt="Yashoda Hospital" />
              <div className="location-content">
                <h3>Yashoda Hospital</h3>
                <p>🏥 Specialty Surgical Center</p>
                <p>📍 JNTU to Hitec City Road, Kothaguda, Hyderabad, Telangana – 500 084</p>
                <p>📞 91-40-4567 4567</p>
                <p>🕒 Mon-Sat: 8AM-8PM</p>
              </div>
            </div>
            <div className="location-card">
              <img src="https://www.practo.com/consumer-ui/_next/image?url=https%3A%2F%2Fimages1-fabric.practo.com%2Fpractices%2F1238966%2Fkims-hospital-hyderabad-6656d8dd11ab5.jpg&w=3840&q=75" alt="Kukatpally" />
              <div className="location-content">
                <h3>Kims Hospital</h3>
                <p>🏥 Multi-Specialty Clinic</p>
                <p>📍 Krishna Nagar Colony, Ramgopalpet, Begumpet, Secunderabad, Telangana 500003</p>
                <p>📞 +91-40-4488 5184</p>
                <p>🕒 Mon-Sat: 9AM-7PM</p>
              </div>
            </div>
            <div className="location-card">
              <img src="https://s3.ap-southeast-1.amazonaws.com/images.deccanchronicle.com/dc-Cover-ja4fks9bma2kk0ltqqqt79qdt6-20230731231434.Medi.jpeg" alt="Secunderabad" />
              <div className="location-content">
                <h3>Osmania General Hospital</h3>
                <p>🏥 Advanced Care Center</p>
                <p>📍 Near Afzal Gunj Bus Stop, Begum Bazar, Afzal Gunj, Hyderabad – 500012</p>
                <p>📞 +91 40 2353 8846</p>
                <p>🕒 Mon-Sun: 8AM-8PM</p>
              </div>
            </div>
            <div className="location-card">
              <img src="https://www.yashfiin.com/wp-content/uploads/2020/01/care_hospitals.jpg" alt="Hitech City" />
              <div className="location-content">
                <h3>Care Hospitals</h3>
                <p>🏥 Outpatient & Diagnostic Center</p>
                <p>📍Road No. 1, Banjara Hills, Hyderabad, Telangana – 500034</p>
                <p>📞 +91-40-6810 6589</p>
                <p>🕒 Available 24/7 (same number for emergency/general inquiries)</p>
              </div>
            </div>
            <div className="location-card">
              <img src="http://travocure.com/wp-content/uploads/2021/11/Secundrabad-Sunshine-Branch.jpg" alt="Dilsukhnagar" />
              <div className="location-content">
                <h3>Sunshine Hospitals</h3>
                <p>🏥 multispeciality tertiary care hospital</p>
                <p>📍 Penderghast Road, Opposite Parsi Dharamsala  Behind Paradise Hotel, Secunderabad, Telangana – 500003</p>
                <p>📞 +91-40-4455 0000</p>
                <p>🕒 Mon-Sun: 24/7 Services</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="testimonials-section">
        <div className="container">
          <h2 className="section-title">What Our Patients Say</h2>
          <div className="testimonials-grid">
            <div className="testimonial-card">
              <p>"The care I received was exceptional. The staff was attentive and professional!"</p>
              <h4>Mounika</h4>
            </div>
            <div className="testimonial-card">
              <p>"I felt safe and well taken care of during my treatment. Highly recommend!"</p>
              <h4>Ashotosh </h4>
            </div>
            <div className="testimonial-card">
              <p>"The expertise and compassion shown by the team was outstanding."</p>
              <h4>Ramana</h4>
            </div>
          </div>
        </div>
      </section>

      {/* <section className="cta-section">
        <div className="container">
          <div className="cta-content">
            <h2 className="cta-title">Ready to Begin Your Journey?</h2>
            <p className="cta-description">
              Experience world-class healthcare with our expert team
            </p>
            <div className="cta-buttons">
              <button className="cta-primary">
                                <NavLink className='appointmentabout' to='/bookappointment'>Book Appointment</NavLink>
                
              </button>
              <button className="cta-secondary">Learn More</button>
            </div>
          </div>
        </div>
      </section> */}
    </main>
  )
}

export default AboutUs
